// export const value = state => {
//     return state.value;
//   }

let getters = {
     testVueXGetter (state) {
          return state.testVar
     }
};

export default getters;